import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import ShowState from './components/ShowState'

ReactDOM.render(
  <ShowState>
  <React.StrictMode>
    <App />
  </React.StrictMode>
  </ShowState>,
  document.getElementById('root')
);


reportWebVitals();
